import React, { useState, useContext } from 'react';
import normalize from 'components/Dashboard/utilities/normalizeString';
import MembershipSelectFilter from './MembershipSelectFilter';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import TagsFilter from './TagsFilter';
import { useCollapse } from 'react-collapsed';
import SelectFilter from 'components/Dashboard/Filters/ui/SelectFilter';
import { store } from 'components/Store';
let referenceValue = 6;
let splitItemValue = 4;
const CommonFilter = (props) => {
  const { filter, selectOption, notRow } = props;
  const {
    name,
    options: propOptions,
    additionalItemsText,
    showAllOptions,
    type,
    subtype,
    disabled,
    filterName,
    expandedByDefault,
    showAll,
  } = filter;
  const { agencyUser, newAgencyPlan } = useTopicOrClientWord();
  const options = propOptions.filter((option) => !option.hidden && (!option.agencyOnly || newAgencyPlan));
  const changeFilter = (selected, index, name) => {
    let newValue = [...options];
    if (filterName === 'tags') {
      let i = newValue.findIndex((item) => item.name === name);
      let currentOption = newValue[i];
      currentOption.selected = selected ? !selected : true;
    } else {
      let currentOption = newValue[index];
      if (name) {
        if (!selected) {
          currentOption.selected = true;
        }
        currentOption.optionSelected = name;
      } else {
        currentOption.selected = selected ? !selected : true;
      }
    }

    selectOption({ filter, newValue });
  };
  let optionsToRender = options.length > referenceValue && !showAllOptions ? options.slice(0, splitItemValue) : options;
  let additionalItems = showAllOptions ? [] : options.slice(splitItemValue, options.length);

  return (
    <>
      <h3 className={`${disabled ? 'main-light-text' : ''}`}>
        {name}
        {disabled && (
          <span
            className='ml-2 icon-padlock d-inline-block'
            data-tooltip-content={`Upgrade to ${agencyUser ? '' : 'Mogul or '}Enterprise for sentiment analysis`}
            data-tooltip-id={'general-tooltip'}
          />
        )}
      </h3>
      {type === 'membership' && subtype !== 'Teammates' && subtype !== 'Clients' && (
        <MembershipSelectFilter {...props} notIncludeName useInPopUp />
      )}
      {type === 'membership' && (subtype === 'Teammates' || subtype === 'Clients') && (
        <SelectFilter {...props} notIncludeName useInPopUp />
      )}
      {/* Legacy plain-checkbox tags filter (e.g. Directory's own Tag filter, no `type`) - newer
          membership-type tag filters (e.g. CrmInteractions' Tag, type: 'membership', subtype:
          'CrmInteractionTags') already render above via MembershipSelectFilter, so this needs to
          explicitly exclude them or both components render for the same filter at once. */}
      {filterName === 'tags' && type !== 'membership' && <TagsFilter {...props} />}
      <div
        className={`${
          options.length >= splitItemValue && !showAllOptions && !notRow
            ? 'row'
            : options.length > 0
            ? 'd-flex flex-column row'
            : ''
        }`}
      >
        {optionsToRender.map((option, index) => (
          <FilterItem
            option={option}
            options={optionsToRender}
            key={`option-filter${index}`}
            index={index}
            changeFilter={changeFilter}
            notRow={showAllOptions || notRow}
            type={type}
            parentDisabled={disabled}
            filterName={filterName}
            idPrefix='popup-'
          />
        ))}
      </div>
      {additionalItems.length > 0 && options.length > referenceValue && (
        <AdditionalItemDropdown
          additionalItems={additionalItems}
          changeFilter={changeFilter}
          additionalItemsText={additionalItemsText}
          type={type}
          notRow={notRow}
          parentDisabled={disabled}
          filterName={filterName}
          expanded={expandedByDefault}
          showAll={showAll}
        />
      )}
    </>
  );
};

const AdditionalItemDropdown = (props) => {
  const {
    additionalItems,
    changeFilter,
    additionalItemsText,
    type,
    notRow,
    parentDisabled,
    filterName,
    expanded = false,
    showAll,
  } = props;

  const [isExpanded, setExpanded] = useState(expanded);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  return (
    <>
      <div {...getCollapseProps()}>
        <div className={`${!notRow ? 'row' : ''} transition-item overflow-hidden`}>
          {additionalItems.map((option, index) => (
            <FilterItem
              option={option}
              options={additionalItems}
              key={`additional-filter${index}`}
              index={index + splitItemValue}
              changeFilter={changeFilter}
              type={type}
              notRow={notRow}
              parentDisabled={parentDisabled}
              filterName={filterName}
              idPrefix='popup-'
            />
          ))}
        </div>
      </div>

      {!(isExpanded && showAll) && (
        <button
          className={`mt-3 d-inline-block simple-link-button general-button showitem-button mb-3 ${
            isExpanded ? 'closeitem-button' : ''
          }`}
          {...getToggleProps({
            onClick: () => setExpanded((prevExpanded) => !prevExpanded),
          })}
        >
          {isExpanded ? 'Close' : 'Show'} all {additionalItemsText ? additionalItemsText : ''}
        </button>
      )}
    </>
  );
};

const FilterItem = (props) => {
  const { option, index, changeFilter, notRow, insideDropDown, type, parentDisabled, filterName, idPrefix = '' } =
    props;
  const { name, selected, suboptions, optionSelected, tooltip, disabled } = option;
  const globalState = useContext(store);
  const { state } = globalState;
  const dynamicNameCondition = name.startsWith('${') && name.endsWith('}');

  const resolveDynamicValue = (value) => {
    if (dynamicNameCondition) {
      const path = value.startsWith('${') && value.endsWith('}') ? value.slice(2, -1) : value;
      // Check if it contains dots (indicating a path to resolve)
      if (path.includes('.')) {
        const pathParts = path.split('.');
        // Navigate through the state using the path parts
        let currentValue = state;
        for (const part of pathParts) {
          currentValue = currentValue?.[part];
          if (currentValue === undefined || currentValue === null) {
            return ''; // Return empty string if path doesn't exist
          }
        }
        return currentValue;
      }
    }
    return value;
  };

  const resolvedName = resolveDynamicValue(name);

  return (
    <div
      className={`filter-item-container ${!notRow ? 'col-md-8' : 'filter-item-checkbox'} ${
        suboptions ? 'filter-item-checkbox-suboptions' : ''
      } ${insideDropDown ? 'filter-item-dropdown' : ''}`}
    >
      <div
        className={`checkbox-item filter-item-${normalize(resolvedName)} ${
          disabled || parentDisabled ? 'checkbox-item-disabled' : ''
        }`}
      >
        <input
          id={`${idPrefix}${normalize(resolvedName)}${type === 'TagIsNot' ? type : ''}`}
          onChange={() => {
            if (filterName === 'tags') {
              changeFilter(selected, index, name);
            } else {
              changeFilter(selected, index);
            }
          }}
          type={`checkbox`}
          disabled={disabled || parentDisabled}
          checked={selected ?? false}
        />
        <label htmlFor={`${idPrefix}${normalize(resolvedName)}${type === 'TagIsNot' ? type : ''}`}>{resolvedName}</label>
        <TooltipFilterComponent tooltip={tooltip} />
      </div>
      {suboptions && (
        <ul className='policy-list filters-indented-list mb-0 pb-2 suboptions-list'>
          {suboptions.map((suboption, suboptionIndex) => {
            const { name } = suboption;
            const resolvedSuboptionName = resolveDynamicValue(name);
            const identifier = `${idPrefix}${normalize(resolvedName)}-${normalize(resolvedSuboptionName)}-${suboptionIndex}`;
            return (
              <li
                className={`radio-button ${suboptionIndex < suboptions.length - 1 ? 'mb-2' : ''}`}
                key={`${identifier}`}
              >
                <input
                  id={identifier}
                  onChange={() => {
                    changeFilter(selected, index, name);
                  }}
                  type='radio'
                  checked={optionSelected === name && selected}
                />
                <label htmlFor={identifier}>{resolvedSuboptionName}</label>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

const TooltipFilterComponent = ({ tooltip, tooltipClassName, className }) => {
  return (
    <>
      {tooltip && (
        <span
          className={`icon-info paragraph-p3 specific-left-margin-10 common-filter-option-tooltip text-main-blue-60 ${className}`}
          data-tooltip-content={tooltip}
          data-tooltip-id='general-tooltip'
          data-tooltip-class-name={tooltipClassName}
        ></span>
      )}
    </>
  );
};

export { FilterItem, TooltipFilterComponent };
export default CommonFilter;
